import React from 'react';
import { PhoneIcon, MailIcon, InstagramIcon, MessageCircleIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
import { LinkButton } from '../ui/Button';
import { contact } from '../../data/site';
export function Contact() {
  return <section id="contacto" className="bg-cream py-20 lg:py-28" data-id="element-87" data-mp="1iux9b37cmeyq">
      <div className="mx-auto max-w-shell px-5 lg:px-10" data-id="element-88" data-mp="1mvphru8ecfty">
        <div className="grid gap-12 rounded-[28px] border border-navy/[0.07] bg-white p-8 sm:p-12 lg:grid-cols-2 lg:gap-16 lg:p-16" data-id="element-89" data-mp="18wzjwcdr6c4j">
          <Reveal data-id="element-90" data-mp="1dwcfbliowriq">
            <p className="eyebrow text-teal" data-id="element-91" data-mp="1dwvskoxearqf">Contacto</p>
            <h2 className="mt-5 font-display text-[2rem] font-semibold leading-[1.15] tracking-[-0.02em] text-navy sm:text-[2.5rem]" data-id="element-92" data-mp="zwkxf9p1yqzg">
              ¿Tienes preguntas?
            </h2>
            <p className="mt-5 max-w-md text-[15px] font-light leading-relaxed text-ink/65" data-id="element-93" data-mp="2uaceuvdmif5g">
              Estoy aquí para ayudarte a entender tus opciones.
            </p>

            <div className="mt-9 border-t border-navy/[0.08] pt-7" data-id="element-94" data-mp="2yb4npnil2i17">
              <p className="font-display text-[14px] font-semibold tracking-[0.1em] text-navy" data-id="element-95" data-mp="2b7ey4c0fj6n6">
                {contact.name.toUpperCase()}
              </p>
              <p className="mt-1.5 text-[13.5px] font-light text-ink/60" data-id="element-96" data-mp="2ky9sy4rqrek8">{contact.title}</p>
              <p className="mt-1 eyebrow text-gold" data-id="element-97" data-mp="2fz6p2nnhzedu">{contact.npn}</p>
            </div>
          </Reveal>

          <Reveal delay={0.08} data-id="element-98" data-mp="1s9m7a832yn65">
            <ul className="space-y-4" data-id="element-99" data-mp="1sangs84g71lr">
              <li data-id="element-100" data-mp="1sbos8dpdlq40">
                <a href={contact.phoneHref} className="flex items-center gap-4 text-[15px] text-ink/75 transition-colors duration-200 ease-out hover:text-teal" data-id="element-101" data-mp="1naiz4ert00ty">
                  <PhoneIcon size={17} strokeWidth={1.4} className="text-teal" data-id="element-102" data-mp="229cyo0wcgm20" />
                  {contact.phoneDisplay}
                </a>
              </li>
              <li data-id="element-103" data-mp="3dmff8vyg1bm6">
                <a href={contact.emailHref} className="flex items-center gap-4 break-all text-[15px] text-ink/75 transition-colors duration-200 ease-out hover:text-teal" data-id="element-104" data-mp="3dlw0fo43b3cd">
                  <MailIcon size={17} strokeWidth={1.4} className="shrink-0 text-teal" data-id="element-105" data-mp="3framn6nknbaq" />
                  {contact.email}
                </a>
              </li>
              <li data-id="element-106" data-mp="3ks86ros56fev">
                <a href={contact.instagramHref} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 text-[15px] text-ink/75 transition-colors duration-200 ease-out hover:text-teal" data-id="element-107" data-mp="3pp8dm1wtfm71">
                  <InstagramIcon size={17} strokeWidth={1.4} className="text-teal" data-id="element-108" data-mp="2wyq2qepuogj2" />
                  {contact.instagram}
                </a>
              </li>
            </ul>

            <div className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-109" data-mp="36xfk86du3yys">
              <LinkButton href={contact.phoneHref} variant="primary" data-id="element-110" data-mp="3bqig4l633ki5">
                <PhoneIcon size={15} strokeWidth={1.6} data-id="element-111" data-mp="2eab9dks28qf3" />
                LLAMAR
              </LinkButton>
              <LinkButton href={contact.whatsapp} target="_blank" rel="noopener noreferrer" variant="ghost" data-id="element-112" data-mp="2j8w8thzhn62h">
                <MessageCircleIcon size={15} strokeWidth={1.6} data-id="element-113" data-mp="10ebc5dpoccsu" />
                WHATSAPP
              </LinkButton>
              <LinkButton href={contact.emailHref} variant="ghost" data-id="element-114" data-mp="wdhpennyx41j">
                <MailIcon size={15} strokeWidth={1.6} data-id="element-115" data-mp="rd3ff02t3k0v" />
                EMAIL
              </LinkButton>
              <LinkButton href={contact.instagramHref} target="_blank" rel="noopener noreferrer" variant="ghost" data-id="element-116" data-mp="mes3mjsyazg0">
                <InstagramIcon size={15} strokeWidth={1.6} data-id="element-117" data-mp="hffludgxsika" />
                INSTAGRAM
              </LinkButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}